import { isCookieSettingsHash } from '~/utils/oneTrustUtils';

export default {
  scrollBehavior (to: any, from: any, savedPosition: any) {
    /*
     * `#cookie-setting` is an action hash for the OneTrust plugin, not a
     * scroll target — no element carries that id.
     */
    if (isCookieSettingsHash(to.hash)) {
      return false;
    }
    /*
     * A hash cleared in place (e.g. the consumed `#cookie-setting`) is a URL
     * clean-up, not a navigation — don't yank the page away.
     */
    if (!to.hash && from.hash && to.path === from.path) {
      return false;
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      };
    }
    if (savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ ...savedPosition, behavior: 'instant' });
        }, 500);
      });
    }
    /*
     * Initial load / hard reload (`from` is START_LOCATION): defer to the
     * browser's native scroll restoration.
     */
    if (from.matched.length === 0) {
      return false;
    }
    return { top: 0, behavior: 'instant' };
  }
};
